// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import batteryMidIcon from "@/assets/icons/battery-mid.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type BatteryMidIconProps = Omit<IconProps, "name">;

export function BatteryMidIcon(props: BatteryMidIconProps): React.ReactNode {
  return <Icon name={batteryMidIcon} {...props} />;
}
